/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.directives {

    export interface ISimpleOperandScope extends IOperandScope {
        getTreeItemName(): string;
        getTreeItemIconName(): string;
        getDetailedTreeItemDisplay(): string;
        getOperand(): Wars.Domain.Model.Calculations.SimpleOperand;
        detailedTreeItemDisplay: string;
        treeItemDisplayInternal: string;
        onDragOver($event: any) : void;
        onDrop($event: any): void;
    }

    export class SimpleOperand implements IDirective {
        public templateUrl: string = './app/views/directives/calculate/simpleOperand.html';
        public restrict: string = 'E';
        public controller = ['$scope', 'treeService', SimpleOperandController];
        public controllerAs = 'controller';
        public scope: boolean = true; // False is use parents scope - True is create inherited scope from parents scope

        public link($scope: ISimpleOperandScope, element: JQuery, attrs: ng.IAttributes, controller: SimpleOperandController) { }
    }

    export class SimpleOperandController implements IController {
        
        constructor(private $scope: ISimpleOperandScope, private treeService: services.TreeService) {
            // Public methods using lambdas to preserve this
            this.$scope.getTreeItemName = () => this.getTreeItemNameInternal();
            this.$scope.getTreeItemIconName = () => this.getTreeItemIconNameInternal();
            this.$scope.getOperand = () => this.getOperandInternal();
            this.$scope.onDragOver = ($event: any) => this.onDragOverInternal($event);
            this.$scope.onDrop = ($event: any) => this.onDropInternal($event);
            
            // When the normal display of the tree item changes update the detailed display.
            this.$scope.$watch("treeItemDisplayInternal",
                () => {
                    this.updateDetailedTreeItemDisplay();
                });
        }

        private onDragOverInternal($event: any): void {
            
        }

        private onDropInternal($event: any): void {
            var treeItem = this.treeService.createTreeItemFromItemDropped();

            var operand = this.getOperandInternal();
            operand.treeItem = treeItem;
            operand.treeItem_id = treeItem.id;

            $event.preventDefault();
            $event.stopPropagation();

            this.treeService.clearDragValue();
        }

        private getOperandInternal(): Wars.Domain.Model.Calculations.SimpleOperand {
            return <Wars.Domain.Model.Calculations.SimpleOperand>this.$scope.getOperation().operands[this.$scope.operandIndex];
        }

        private getTreeItemNameInternal() {
            var operand = this.getOperandInternal();
            if (!operand) {
                this.$scope.treeItemDisplayInternal = '';
                return this.$scope.treeItemDisplayInternal;
            }
            var treeItem = operand.treeItem;
            if (!treeItem) {
                this.$scope.treeItemDisplayInternal = '';
                return this.$scope.treeItemDisplayInternal;
            }
            this.$scope.treeItemDisplayInternal = this.treeService.getDisplayName(treeItem) + ' of ' + this.treeService.getParentDisplayName(treeItem);
            return this.$scope.treeItemDisplayInternal; 
        }

        private getTreeItemIconNameInternal(): string {
            var operand = this.getOperandInternal();
            if (!operand) return '';
            var treeItem = operand.treeItem;
            if (!treeItem) return '';
            return this.treeService.getParentDisplayIcon(treeItem);
        }

        private updateDetailedTreeItemDisplay(): void {
            if (this.$scope.treeItemDisplayInternal === undefined ||
                this.$scope.treeItemDisplayInternal === null ||
                this.$scope.treeItemDisplayInternal === "") {
                return;
            }
            var operand = this.getOperandInternal();
            if (!operand) return;
            var treeItem = operand.treeItem;
            if (!treeItem) return;
            if (!treeItem.id) return;

            this.treeService.getDetailedDisplayName(treeItem).then((detailedDisplay) => {
                this.$scope.detailedTreeItemDisplay = detailedDisplay;
            });
        }
    }
}

warsApp.registerDirective('SimpleOperand', []);